import { SearchEngine } from './common'

const defaultFieldSpecifiers = [
  { name: 'title', value: 'Title' },
  { name: 'author', value: 'ContribAuthor' },
  { name: 'abstract', value: 'Abstract' },
  { name: 'full text', value: 'Fulltext' },
  { name: 'author affiliation', value: 'Affiliation' },
  { name: 'author keyword', value: 'Keyword' },
  { name: 'conference location', value: 'ConferenceLocation' },
  { name: 'conference sponsor', value: 'ConferenceSponsor' },
  { name: 'name', value: 'Contrib' },
  { name: 'isbn/issn', value: 'PubIdSortField' },
  { name: 'doi', value: 'DOI' },
  { name: 'aftermonth', specific: 'AfterMonth' },
  { name: 'afteryear', specific: 'AfterYear' },
  { name: 'beforemonth', specific: 'BeforeMonth' },
  { name: 'beforeyear', specific: 'BeforeYear' }
]

const defaultSyntaxGuideUrl = 'https://dl.acm.org/search/advanced'

class AcmEngine extends SearchEngine {
  constructor (fieldSpecifiers) {
    super('ACM Guide')
    this.fieldSpecifiers = fieldSpecifiers || defaultFieldSpecifiers
    this.syntaxGuideUrl = defaultSyntaxGuideUrl
  }
  resetQueryParameters () {
    this.specifics = []
  }
  formTerm (text, isNegative, addQuotes, fieldSpecifier) {
    let s
    if (fieldSpecifier && fieldSpecifier.length > 0) {
      s = this.fieldSpecifiers.find(sfs => sfs.name === fieldSpecifier.toLowerCase())
      if (s && s.specific) {
        this.specifics.push({ name: s.specific, value: text })
        return ''
      }
    }
    let r = ''
    if (isNegative) {
      r += '-'
    }
    if (s) {
      r += s.value + ':'
    } else {
      r += 'AllField:'
    }
    if (addQuotes) {
      r += '"'
    }
    r += text
    if (addQuotes) {
      r += '"'
    }
    return encodeURIComponent(r)
  }
  formulateQuery (query) {
    let r = 'https://dl.acm.org/action/doSearch?fillQuickSearch=false&expand=dl&'
    if (this.specifics.length > 0) {
      this.specifics.forEach(item => {
        r += `${item.name}=${item.value}&`
      })
    }
    r += 'AllField=' + query
    return r
  }
  formulateDisplayQuery (query) {
    const monthTo = this.specifics.find(s => s.name === 'BeforeMonth')
    const yearTo = this.specifics.find(s => s.name === 'BeforeYear')
    const monthFrom = this.specifics.find(s => s.name === 'AfterMonth')
    const yearFrom = this.specifics.find(s => s.name === 'AfterYear')
    const to = `${monthTo ? monthTo.value + '/' : ''}${yearTo ? yearTo.value : ''}`
    const from = `${monthFrom ? monthFrom.value + '/' : ''}${yearFrom ? yearFrom.value : ''}`
    const toFrom = `${from}${from && to ? ' ' : ''}${to}`
    return `${decodeURIComponent(query)} ${toFrom ? '(' + toFrom + ')' : ''}`
  }
  lintQuery (queryGraphData) {
    const m = this.lintFieldSpecifiers(queryGraphData, this.fieldSpecifiers)
    return m ? [m] : []
  }
  getSuggestTermsMetaData () {
    return this.getSuggestTermsDbpediaSettings()
  }
}
// https://dl.acm.org/action/doSearch?fillQuickSearch=false&expand=dl
//   &AfterMonth=1&AfterYear=1980&BeforeMonth=12&BeforeYear=2000
//   &AllField=Title%3A%28bubble%29+AND+ContribAuthor%3A%28kubo%29
//
// https://dl.acm.org/action/doSearch?fillQuickSearch=false&expand=dl
//   &AllField=AllField%3A%28kubo%29+AND+Title%3A%28bubble%29
export default AcmEngine



// WEBPACK FOOTER //
// ./src/formulate_queries/AcmEngine.js